import { render } from "./CustomHotelMeeting.vue?vue&type=template&id=b05f8bfc&scoped=true"
import script from "./CustomHotelMeeting.vue?vue&type=script&lang=js"
export * from "./CustomHotelMeeting.vue?vue&type=script&lang=js"

import "./CustomHotelMeeting.vue?vue&type=style&index=0&id=b05f8bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05f8bfc"]])

export default __exports__